import { useEffect, useState } from 'react'

import { Box, Button, Container, TextField, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from '@material-ui/lab'

import api from 'common/api'

const useStyles = makeStyles((theme) => ({
  passwordContainer: {
    padding: theme.spacing(3, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  editPasswordSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

const SecurityContent = () => {
  const classes = useStyles()
  const [isEditing, setIsEditing] = useState(false)
  const [updatedPass, setUpdatedPass] = useState({
    currentPassword: '',
    password: '',
    confirmedPassword: '',
  })
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [minPasswordLength, setMinPasswordLength] = useState(8)

  useEffect(() => {
    api
      .get<{ minPasswordLength: number }>('/api/user/password/requirements')
      .then((res) => setMinPasswordLength(res.minPasswordLength))
      .catch(() => {})
  }, [])

  const onEdit = () => {
    setIsEditing(!isEditing)
    setSuccess(false)
    setError(false)
  }

  const handleUpdate = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { name, value } = e.target
    setUpdatedPass((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const isPasswordInvalid = () => {
    return updatedPass.password.length > 0 && updatedPass.password.length < minPasswordLength
  }

  const isConfirmPasswordInvalid = () => {
    return updatedPass.confirmedPassword.length > 0 && updatedPass.password !== updatedPass.confirmedPassword
  }
  const disableSubmit = () => {
    return (
      updatedPass.confirmedPassword.length === 0 ||
      updatedPass.password.length === 0 ||
      isPasswordInvalid() ||
      isConfirmPasswordInvalid()
    )
  }

  const submitReset = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setError(false)
    api
      .post('/api/user/password', {
        ExistingPassword: updatedPass.currentPassword,
        Password: {
          Pass: updatedPass.password,
          PassConfirm: updatedPass.confirmedPassword,
        },
      })
      .then(() => {
        setIsEditing(false)
        setSuccess(true)
      })
      .catch(() => setError(true))
  }

  return (
    <Container maxWidth="lg">
      <Typography
        variant="h6"
        component="h1"
      >
        Security
      </Typography>
      {success && (
        <Alert severity="success">
          Your password has been successfully changed.You can use your new password the next time you log in.
        </Alert>
      )}
      <Box className={classes.passwordContainer}>
        <Box className={classes.editPasswordSection}>
          <Typography>
            <b>Password</b>
          </Typography>
          <Button
            color="primary"
            variant="text"
            onClick={onEdit}
          >
            {isEditing ? 'Cancel' : 'Edit'}
          </Button>
        </Box>
        {isEditing && (
          <>
            <TextField
              type="password"
              name="currentPassword"
              label="Current Password"
              onChange={handleUpdate}
              required
              margin="normal"
              variant="outlined"
              fullWidth
            />
            <TextField
              type="password"
              name="password"
              label="New Password"
              helperText={`Enter at least ${minPasswordLength} characters`}
              onChange={handleUpdate}
              required
              error={isPasswordInvalid()}
              margin="normal"
              variant="outlined"
              fullWidth
            />
            <TextField
              type="password"
              name="confirmedPassword"
              label="Confirm Password"
              onChange={handleUpdate}
              required
              margin="normal"
              variant="outlined"
              error={isConfirmPasswordInvalid()}
              fullWidth
            />
            <Box
              display="flex"
              gridGap={16}
              alignItems="center"
            >
              <div>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={disableSubmit()}
                  onClick={submitReset}
                >
                  Reset
                </Button>
              </div>
              {error && <Alert severity="error">Unable to change your password, please try again later.</Alert>}
            </Box>
          </>
        )}
      </Box>
    </Container>
  )
}

export default SecurityContent
